import { render, staticRenderFns } from "./UpsertRewardCategory.vue?vue&type=template&id=cffe8fd8"
import script from "./UpsertRewardCategory.vue?vue&type=script&lang=js"
export * from "./UpsertRewardCategory.vue?vue&type=script&lang=js"
import style0 from "./UpsertRewardCategory.vue?vue&type=style&index=0&id=cffe8fd8&prod&lang=css"
import style1 from "./UpsertRewardCategory.vue?vue&type=style&index=1&id=cffe8fd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports